export default __webpack_public_path__ + "static/media/017-haystack.10febb8b.svg";